var scope_0 = require('/home/monkey/Projects/bkc-sajt/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;
var scope_1 = require('/home/monkey/Projects/bkc-sajt/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/ebf45247627d0a749fcf2ea3e44a2ac7.js').default;export default
        Object.assign({}, scope_0,
scope_1 )
    